var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"back-to-top",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"el-icon-caret-top",attrs:{"color":"#3c427c"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }